import AddRounded from '@mui/icons-material/AddRounded';
import Article from '@mui/icons-material/Article';
import { IconButton } from '@src/common/components/IconButton';
import { useFindAllNotesForPermit } from '@src/notes/hooks/useFindAllNotesForPermit';
import { useCurrentOrderMode } from '@src/orders/hooks/useCurrentOrderMode';
import { useTranslation } from 'react-i18next';

interface Props {
  permitId: string;
  mode: 'permitNotes' | 'reviewPermitNotes';
  disabled?: boolean;
}

export const PermitNotesButton = ({
  permitId,
  mode,
  disabled = false,
}: Props) => {
  const { t } = useTranslation();
  const { notes } = useFindAllNotesForPermit(permitId);
  const { setCurrentMode } = useCurrentOrderMode();
  const hasNotes = notes && notes.length > 0;

  return (
    <IconButton
      disabled={disabled}
      onClick={() => setCurrentMode({ mode, permitId })}
      title={t('notes.open')}
    >
      {hasNotes ? <Article /> : <AddRounded />}
    </IconButton>
  );
};
